













































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import breadcrumb from "@/components/common/breadcrumb.vue";
import upload from "@/components/upload/src/index.vue";
import SpuSearchList from "@/components/item/SpuSearchList.vue";
import {
  checkSpecAlign,
  getItemExcel,
  getSpecSelect,
  previewSpecAlign,
  queryItemDetail,
  recommendSpu,
  saveItemDetail,
  saveItemExcel,
  saveSpecAlign,
  getTaskLogList
} from '@/services/api';
import SpuManage from "@/model/Spu";
import {Good, GoodSpec, ItemManage} from "@/model/Item";
import {DefaultSpec, SpecManage, SpecSelect, specSpu, SpecTable} from "@/model/Spec";
import store from "@/store";
import {isObjectValueEqualNew} from "@/services/common";
import Task from "@/model/Task";

export enum Tab {
  'ITEM',
  'SPEC'
}

@Component({
  components: {
    'zf-breadcrumb': breadcrumb,
    'zf-upload': upload,
    'spu-search-list': SpuSearchList
  },
})
export default class ItemPerfect extends Vue{
  // todo ts,css整理
  //面包屑导航
  public navList: {name: String, to?: String}[] = [
    {name: 'item列表', to: '/item/list'},
    {name: 'item完善'}
  ];
  Tab = Tab;
  public tab: Tab = this.Tab.ITEM;

  //编辑的itemId
  private itemId!: number;
  private taskId!: number|undefined;
  // item信息
  public itemData: ItemManage = {goods: []};
  public originItemData: ItemManage = {goods: []};
  // 错误信息套餐信息
  public errorGoodIds:number[] = [];
  // 错误信息弹框是否显示
  public checkGoodInfoVisible = false;
  // good表格合并
  public goodSpanCtrl: number[][] = [[]];

  // spu表格
  public spuList: SpuManage[] = [];
  // 关联spu请求完毕
  public recommendSpuLoading = false;
  // spu列表显示控制
  public dialogVisible = false;

  // 当前对齐的spec
  public goodSpec: GoodSpec = {};
  // spec对齐信息
  private specData: SpecManage = {};
  private originSpecData: SpecManage = {};
  // spec表格信息（对齐信息的展示）
  public specTableData: SpecTable[] = [];
  // spec表格合并
  public specSpanCtrl: number[] = [];
  // spec下拉列表
  public specSelect: SpecSelect = {};

  // spec预览数据
  public specPreview: specSpu[] = [];
  // spec预览显示控制
  public previewVisible = false;

  // excel下载截流控制
  public excelCtrl = true;

  // 检查有无修改
  public checkTimer!: number;
  public itemModified = false;
  public specModified = false;

  public taskList: Task[] = [];

  async created(): Promise<void> {
    this.itemId = parseInt(this.$route.params.itemId);
    this.taskId = this.$route.params.taskId? parseInt(this.$route.params.taskId) : undefined;
    await this.queryItemDetail();
    await this.recommendSpu();
    this.checkTimer = setInterval(() => {
      if (this.tab === this.Tab.ITEM) {
        this.itemModified = !isObjectValueEqualNew(this.itemData, this.originItemData);
      } else if (this.tab === this.Tab.SPEC) {
        this.specTableToData();
        this.specModified = !isObjectValueEqualNew(this.specData, this.originSpecData);
      }
    }, 1000);
  }

  beforeDestroy() {
    clearInterval(this.checkTimer);
  }

  getTaskLogList() {
    getTaskLogList({taskKey: this.itemId, taskType: 1}).then(res => {
        if (res.data && res.data.code === 200) {
          this.taskList = res.data.data.list || [];
        }
    })
  }
  /**
   * 获取item详情
   */
  async queryItemDetail(): Promise<void> {
    if (this.itemId) {
      await queryItemDetail({itemId: this.itemId, taskId: this.taskId}, true).then(res => {
        if (res.data && res.data.code === 200) {
          this.itemData = res.data.data || {goods: []};
          this.goodSpanInit();
          this.originItemData = JSON.parse(JSON.stringify(this.itemData));
          this.itemModified = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.getTaskLogList();
    }
  }

  /**
   * 获取关联spu信息
   */
  async recommendSpu(): Promise<void> {
    this.recommendSpuLoading = true;
    if (this.itemId) {
      await recommendSpu({itemId: this.itemId}, false).then(res => {
        if (res.data && res.data.code === 200) {
          this.spuList = res.data.data || [];
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
    this.recommendSpuLoading = false;
  }
  //套餐阈值弹窗控制
  checkGoodInfoDialog(){
    this.checkGoodInfoVisible = false;
    this.errorGoodIds = []
  }
  //将套餐id转化为套餐序号
  transformGoodIdToIndex(){
    let indexErrorGoodIds :number[] = [];
    for(const errorGoodId of this.errorGoodIds){
      for (const [index, good] of (this.itemData.goods||[]).entries()){
        if(good.id === errorGoodId ){
          indexErrorGoodIds.push(index+1)
        }
      }
    }
    this.errorGoodIds = indexErrorGoodIds
    this.checkGoodInfoVisible = true;
  }
  /**
   * 保存提交
   */
  async submit(status: number) {
    if (status === 2 && !this.checkForm()) {
      return;
    }
    if (status === 1) {
      try {
        const remark: any = await this.$prompt('请输入回退原因: ','', {closeOnClickModal: false});
        this.itemData.remark = remark.value;
      } catch (e) {
        return;
      }
    }
    this.itemData.status = status;
    saveItemDetail(this.itemData, true).then(res => {
      if(res.data && res.data.code === 404){
        this.errorGoodIds = res.data.data?.errorInfoGoodIds || [];
        // this.transformGoodIdToIndex()
        this.$message.error(res.data.message);
      }
      else if (res.data && res.data.code === 200) {
        this.$message.success('保存成功');
        this.originItemData = JSON.parse(JSON.stringify(this.itemData));
        this.itemModified = false;
        this.$router.push('/task/list/');
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(() => {})
  }

  /**
   * 校验表单内容是否通过
   */
  checkForm(): boolean {
    for (let [goodIndex, good] of (this.itemData.goods||[]).entries()) {
      for (let [specIndex, spec] of (good.specs||[]).entries()) {
        if (!spec.baseSpuId || !spec.count) {
          this.$message.error(`套餐spu扣减数未填写：可选套餐${goodIndex + 1}，第${specIndex + 1}行`)
          return false;
        }
      }
    }
    return true;
  }

  /**
   * 添加spu
   */
  addSpu(spuAddList: SpuManage[]) {
    let filterObj: any = {}
    this.spuList = this.spuList.concat(spuAddList).filter(item => {
      if (!item.spuId) {
        return false;
      }
      if (filterObj[item.spuId]) {
        return false;
      } else {
        filterObj[item.spuId] = true;
        return true;
      }
    });
    this.dialogVisible = false;
  }

  /**
   * 增加规格
   */
  addSpec(good: Good) {
    good.specs = good.specs || [];
    good.specs.push({deletable: true});
    this.goodSpanInit();
  }


  /**
   * 删除规格
   */
  deleteSpec(good: Good, index: number) {
    good.specs?.splice(index, 1)
  }

  /**
   * 合并表格
   * @param index package的序号
   * @param event 事件
   */
  arraySpanMethod({ row, column, rowIndex, columnIndex }: any, index: number) {
    if (columnIndex === 0) {
      return this.itemData.goods && rowIndex === 0 ? [this.itemData?.goods[index]?.specs?.length, 1] : [0, 0];
    }
    // 同spu合并表格事件
    if (columnIndex === 3 || columnIndex === 4) {
      return this.goodSpanCtrl[index][rowIndex] > 0 ? [this.goodSpanCtrl[index][rowIndex], 1] : [0,0]
    }
  }

  /**
   * spu改变钩子函数
   */
  onSpuChange(goodSpec: GoodSpec, spuId: number) {
    // goodSpec.baseSpuName = this.spuList.filter(item => (item.spuId === spuId))[0].name;
    this.goodSpanInit();
  }

  /**
   * 扣减数改变钩子函数
   */
  onCountChange(goodSpec: GoodSpec) {
    goodSpec.count = parseInt(goodSpec.count + '');
    if (goodSpec.count !== 0 && !goodSpec.count) {
      goodSpec.count = undefined;
    }
    if (goodSpec.count && goodSpec.count < 0) {
      goodSpec.count = 0;
    }
    this.goodSpanInit();
  }

  /**
   * 刷新表格控制
   */
  goodSpanInit() {
    this.goodSpanCtrl = this.itemData.goods?.map((good: Good) => {
      good.specs = good.specs || [];
      const spanArr: number[] = [];
      let position = 0; // 表格合并的首行
      for (let [index, goodSpec] of good.specs.entries()) {
        spanArr[index] = 0;
        // 合并的条件(不可删除 && 当前行与表格合并首行的goodSpuId都存在且相同)
        if (!goodSpec.deletable && goodSpec.baseSpuId && good.specs[position].baseSpuId && goodSpec.baseSpuId === good.specs[position].baseSpuId) {
          goodSpec.count = good.specs[position].count; // 向表格合并首行对齐扣减数
        } else {
          position = index; // 更换表格合并的首行
        }
        spanArr[position] += 1;
      }
      return spanArr;
    }) || [[]];
  }

  /**
   * spec关联
   */
  async specAlign(spec: GoodSpec) {
    this.goodSpec = spec;
    // spec接口调用
    await this.checkSpecAlign();
    await this.getSpecSelect();
    // 表格数据初始化
    this.specDataToTable();
    // 显示控制
    this.tab = this.Tab.SPEC;
  }

  /**
   * spec关联数据获取
   */
  async checkSpecAlign() {
    if (this.goodSpec.baseSpuId) {
      await checkSpecAlign({...this.itemData, checkSpuId: this.goodSpec.baseSpuId}, true).then(res => {
        if (res.data && res.data.code === 200) {
          this.specData = res.data.data || {};
          // this.goodSpec.baseSpuName = this.specData.baseSpuName;
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }

  /**
   * spec关联下拉选项数据获取
   */
  async getSpecSelect() {
    if (this.goodSpec.baseSpuId) {
      await getSpecSelect({baseSpuId: this.goodSpec.baseSpuId}, true).then(res => {
        if (res.data && res.data.code === 200) {
          this.specSelect = res.data.data || {};
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }

  /**
   * spec预览
   */
  async previewSpecAlign() {
    // spec表格提交格式转换
    this.specTableToData();
    await previewSpecAlign(this.specData, true).then(res => {
      if (res.data && res.data.code === 200) {
        this.specPreview = res.data.data || [];
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(() => {});
    this.previewVisible = true;
  }

  /**
   * spec关联保存
   */
  async specSave() {
    // spec和select统一性检查
    let specExist = true;
    let errMessage = '还有未完善的规格大项,请先完善再保存！';
    const arr = this.specSelect.baseSelects?.map(item => item.value) || []
    for (let [index, item] of this.specTableData.entries()) {
      if (arr.indexOf(item.baseSpecId + '') === -1) {
        specExist = false;
        break;
      }
      if (!this.specSelect.valueSelectMap || !item.baseSpecId) {
        specExist = false;
        break;
      }
      const arr2 = this.specSelect.valueSelectMap[item.baseSpecId].map(item => item.value)
      if (arr2.indexOf(item.baseNameId + '') === -1) {
        specExist = false;
        errMessage = `还有未完善的规格小项: 第${index + 1}项,请先完善再保存！`
        break;
      }
    }

    if (!specExist) {
      try {
        await this.$alert(errMessage, '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      } catch(e){}
      return;
    }
    // spec表格提交格式转换
    this.specTableToData();
    await saveSpecAlign(this.specData, true).then(res => {
      if (res.data && res.data.code === 200) {
        this.$message.success('保存成功')
        this.specData = res.data.data || {};
        this.tab = this.Tab.ITEM;
      } else {
        this.$message.error(res.data.message);
      }
    });
  }

  /**
   * 取消spec关联
   */
  specCancel() {
    this.tab = this.Tab.ITEM;
  }

  /**
   * spec关联规格大项选择
   */
  baseSpecSelect(index: number, baseSpecId: string) {
    if (this.specSpanCtrl[index] <= 0) {
      return;
    }
    for (let i = index; i < index + this.specSpanCtrl[index]; i++) {
      this.specTableData[i].baseSpecId = baseSpecId;
      this.specTableData[i].baseSpecName = this.specSelect.baseSelects?.filter(item => (item.value === baseSpecId))[0]?.label;
      this.specTableData[i].baseName = undefined;
      this.specTableData[i].baseNameId = undefined;
    }
  }

  /**
   * spec关联规格小项选择
   */
  baseSelect(spec: SpecTable, id: string) {
    if (this.specSelect.valueSelectMap) {
      spec.baseName = this.specSelect.valueSelectMap[spec.baseSpecId || ''].filter(item => (item.value === id))[0]?.label;
    }
  }

  /**
   * 默认spec关联规格小项选择
   */
  defaultSpecSelect(defaultSpec: DefaultSpec, id: string) {
    if (this.specSelect.valueSelectMap) {
      defaultSpec.baseName = this.specSelect.valueSelectMap[defaultSpec.baseSpecId || ''].filter(item => (item.value === id))[0].label;
    }
  }

  /**
   * spec关联信息表格合并
   */
  specSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex === 1 || columnIndex === 2) {
      return this.specSpanCtrl[rowIndex] !== 0? [this.specSpanCtrl[rowIndex], 1]: [0, 0];
    }
  }

  /**
   * spec表格初始化
   */
  specDataToTable() {
    this.specSpanCtrl = [];
    this.specTableData = [];
    for (let specAlign of (this.specData.specAligns || [])) {
      // 规格大项定位
      let position = this.specSpanCtrl.length;
      for (let valueAlign of (specAlign.values || [])) {
        this.specSpanCtrl.push(0);
        this.specSpanCtrl[position] += 1;
        this.specTableData.push({
          ...valueAlign,
          specId: specAlign.specId,
          baseSpecId: specAlign.baseSpecId,
          specName: specAlign.specName,
          baseSpecName: specAlign.baseSpecName
        })
      }
    }
    this.originSpecData = JSON.parse(JSON.stringify(this.specData));
    this.specModified = false;
  }

  /**
   * spec表格提交格式转换
   */
  specTableToData() {
    const restoreArr = this.specSpanCtrl.filter((i:number) => (i > 0));
    const specAligns = this.specData.specAligns || [];
    // 规格大项定位
    let position = 0;
    // 规格小项定位
    let position2 = 0;
    for (let [index, specAlign] of specAligns.entries()) {
      specAlign.specId = this.specTableData[position].specId;
      specAlign.specName = this.specTableData[position].specName;
      specAlign.baseSpecId = this.specTableData[position].baseSpecId;
      specAlign.baseSpecName = this.specTableData[position].baseSpecName;
      position += restoreArr[index];
      for (let valueAlign of (specAlign.values || [])) {
        valueAlign.baseResource = this.specTableData[position2].baseResource;
        valueAlign.name = this.specTableData[position2].name;
        valueAlign.baseName = this.specTableData[position2].baseName;
        valueAlign.baseNameId = this.specTableData[position2].baseNameId;
        valueAlign.resource = this.specTableData[position2].resource;
        position2 += 1;
      }
    }
  }

  /**
   * 打开新链接图片
   * @param url
   */
  openImg(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * 打开新的窗口
   */
  openWindow(url: string): void {
    window.open(url,'_blank');
  }

  /**
   * excel上传点击
   */
  uploadExcel() {
    const upload:any = this.$refs.uploadExcel;
    upload.click()
  }

  /**
   * excel上传
   */
  async handleUploadChange(i:any) {
    try{
      if (i.target?.files?.length > 0) {
        let params = new FormData()
        params.append('file', i.target.files[0]);
        await saveItemExcel(params).then(res => {
          if (res.data && res.data.code === 200) {
            this.$message.success(res.data.data);
          } else {
            let message = res.data.message;
            if(message.search("item完善超过阀值") != -1){
            let numStr =  message.substring(message.indexOf("[")+1,message.indexOf("]"));
            this.errorGoodIds = numStr.split(",").map(Number) || []
            this.transformGoodIdToIndex()
            }else{
               this.$message.error(res.data.message);
            }

          }
        })
      }
      i.target.value = '';
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * excel下载
   */
  async getItemExcel(): Promise<void> {
    if (this.excelCtrl) {
      this.excelCtrl = false;
      try{
        await getItemExcel({itemId: this.itemId + ''}).then((res:any) => {
          const blob = new Blob(
            [res.data], { type: 'application/vnd.ms-excel; chartset=utf-8'})
          const aEle = document.createElement('a');     // 创建a标签
          const href = window.URL.createObjectURL(blob);       // 创建下载的链接
          aEle.href = href;
          aEle.download = decodeURI(res.headers['content-disposition'].replace('attachment;filename=', ''));  // 下载后文件名
          document.body.appendChild(aEle);
          aEle.click();     // 点击下载
          document.body.removeChild(aEle); // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        })
      } catch (e) {
        console.log(e)
      }
      this.excelCtrl = true;
    }

  }

}
